import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ReactNode } from 'react';
import './Layout.css';

interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate("https://qbdconnect.com");
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <div className="home blog wp-custom-logo wp-embed-responsive wp-theme-qbdc-wp elementor-default elementor-kit-655">
      <nav id="navbar">
        <div className="nav-logo">
          <a href="/">
            <img src="https://www.qbdconnect.com/wp-content/themes/qbdc-wp/images/logo-transparent-with-white-and-green.png" alt="QBD Connect"/>
          </a>
        </div>
        <button className="nav-hamburger" aria-label="Toggle menu" aria-expanded="false">
          <span></span>
          <span></span>
          <span></span>
        </button>
        {isAuthenticated && (
          <div className="nav-links">
            <Link to="/dashboard" className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}>Dashboard</Link>
            <Link to="/instances" className={`nav-link ${isActive('/instances') ? 'active' : ''}`}>Instances</Link>
            <Link to="/billing" className={`nav-link ${isActive('/billing') ? 'active' : ''}`}>Billing</Link>
            <a href="https://workhorseintegrations.atlassian.net/servicedesk/customer/portal/4" className="nav-link" target="_blank" rel="noopener noreferrer">Support</a>
            <Link to="/profile" className={`nav-link ${isActive('/profile') ? 'active' : ''}`}>Profile</Link>
            <div className="nav-divider"></div>
            <div className="user-menu">
              <span className="user-name">{user?.alias || user?.firstName || user?.username}</span>
              <button onClick={handleLogout} className="logout-button">Logout</button>
            </div>
          </div>
         )}
      </nav>
      <section className="hero">
        <div className="hero-bg-art">
          <div className="orb orb-1"></div>
          <div className="orb orb-2"></div>
          <div className="orb orb-3"></div>
        </div>
        <div className="hero-grid"></div>
        <div className="hero-content">
          {children}
        </div>
      </section>
      <footer className="footer">
        <script data-jsd-embedded data-key="9c425bd7-9911-4114-a881-fc16f35105c7"
            data-base-url="https://jsd-widget.atlassian.com"
            src="https://jsd-widget.atlassian.com/assets/embed.js">
        </script>
        <p>&copy; 2026 Work Horse Integrations, LLC. All rights reserved.</p>
      </footer>
    </div>
  );
};
